module.exports = __webpack_public_path__ + "static/media/wcm@3x.881a30c5.png";